// ============================================================
// FILE: PortfolioGallery.js
// LOCATION: C:\gardenmarket\web\src\pages\buyer\PortfolioGallery.js
// ============================================================
// PURPOSE:
//   Read-only portfolio photo gallery — drop this into
//   PublicGardenerProfile.js so buyers can see a gardener's
//   sample work alongside their reviews. Mirrors
//   PortfolioSection.js (gardener's own editable version) but
//   with no upload/delete controls.
//
// USAGE (inside PublicGardenerProfile.js):
//   import PortfolioGallery from './PortfolioGallery';
//   ...
//   <PortfolioGallery gardenerId={id} />
//
// PROPS:
//   gardenerId — the gardener_id from the URL param (same one
//                PublicGardenerProfile.js already uses for reviews)
//
// CALLS API:
//   GET /api/photos/portfolio/:gardenerId  — public, no auth
// ============================================================

import { useState, useEffect } from 'react';
import client from '../../api/client';
import { card, cardHeader, colors, radius } from '../../theme/theme';

const API_BASE = 'http://localhost:4000';

export default function PortfolioGallery({ gardenerId }) {
    const [photos,  setPhotos]  = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        client.get(`/photos/portfolio/${gardenerId}`)
            .then(r => setPhotos(r.data.photos || []))
            .catch(console.error)
            .finally(() => setLoading(false));
    }, [gardenerId]);

    if (loading || photos.length === 0) return null;

    return (
        <div style={card}>
            <h3 style={cardHeader}>Portfolio — Sample Work</h3>
            <div style={styles.grid}>
                {photos.map(p => (
                    <img
                        key={p.portfolio_photo_id}
                        src={`${API_BASE}${p.storage_url}`}
                        alt={p.caption || 'Sample work'}
                        style={styles.photo}
                        onError={e => { e.target.style.display = 'none'; }}
                    />
                ))}
            </div>
        </div>
    );
}

const styles = {
    grid:  { display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(100px, 1fr))', gap:'8px' },
    photo: { width:'100%', aspectRatio:'1', objectFit:'cover', borderRadius: radius.sm },
};
